export default __webpack_public_path__ + "static/media/valkiria1.5b434d1c.jpg";